export default __webpack_public_path__ + "static/media/5g-tbox.dcca6205.jpg";